import Configurator from "./configurator";

export const USE_PREVIEW = true;

export default class Preview {

	constructor(node) {
		this.node = node;
		this.init();
	}

	init() {
		const node = this.node;
		// console.log('Preview.init', node);
		const onConfigure = () => {
			Configurator.initConfigurator();
			node.classList.add('hidden');
			node.remove();
		};
		const button = node.querySelector('button');
		button.addEventListener('click', () => {
			onConfigure();
		});
		const ico = node.querySelector('.conf-preview__ico');
		ico.addEventListener('click', () => {
			onConfigure();
		});
	}

	static init() {
		Preview.items = Array.prototype.slice.call(document.querySelectorAll('[data-configurator-preview]')).map((element, id) => {
			return new Preview(element, id);
		});
		if (Preview.items.length === 0) {
			Configurator.initConfigurator();
		}
		// debug__('Preview: ', Preview.items);
	}

}
